import { Box, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { LanguageOptions, SelectLanguageProps } from '../interfaces/components';
import { Close } from '../Icons/Close';
import Language from '../components/common/Language';
import { useTranslation } from 'react-i18next';
import { languageKeys, languageKeysArr, languageNames, languageOptions } from '../utils/helper';
import { disptchCTAClickObject } from '../Analytics';

const SelectLanguage = ({ active, setActive, villageName }: SelectLanguageProps) => {
  const { i18n } = useTranslation();
  // const languages = ['ENGLISH', 'ESPAÑOL', 'CATALÀ', 'ITALIANO', 'FRANÇAISE', '한국어', '中文', 'اللغة العربية'];
  const [selectedLanguage, setSelectedLanguage] = useState<string>('');

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const locale = urlParams.get('locale');

    if (locale && locale != null) {
      if (languageKeysArr.indexOf(locale) !== -1) {
        localStorage.setItem('locale', locale);
        setSelectedLanguage(languageNames[locale]);
        i18n.changeLanguage(locale);
      }
    }
  }, []);

  useEffect(() => {
    if (selectedLanguage && selectedLanguage !== '') {
      // console.log('Selected language', selectedLanguage);
      // console.log('Language Key', languageKeys[selectedLanguage]);
      localStorage.setItem('locale', languageKeys[selectedLanguage]);
      i18n.changeLanguage(languageKeys[selectedLanguage]);
    }
  }, [selectedLanguage]);

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.4)"
        transition="all 1s"
        zIndex={4}
        onClick={() => setActive()}
      />
      <Box
        zIndex={8}
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        backgroundColor="rgba(255, 255, 255, 1);"
        // padding={['15px', '15px', '15px', '15px']}
        width={['95vw', '400px', '450px', '510px', '510px']}
        // height={['370px', '370px', '350px', '360px', '360px']}
        height="max-content"
        pt="10px"
        pb="70px"
      >
        <Close
          boxSize={[6, 6, 7]}
          position="absolute"
          top={['25px', '25px', '25px']}
          right={['25px', '25px', '25px']}
          cursor="pointer"
          onClick={() => setActive()}
          zIndex={30}
        />
        <Text
          textAlign="center"
          fontWeight="400"
          fontSize={['18px', '18px', '18px', '20px', '20px']}
          width="100%"
          mt={['5', '5', '5', '8']}
          className="copy"
          fontFamily="SangBleuBPLight"
          pt={['0', '0', '5']}
        >
          Choose your language
        </Text>

        <Box display="flex" flexDir="row" flexWrap="wrap" gap="3" justifyContent="center" mt="10">
          {languageOptions.map((language: LanguageOptions) => (
            <Language
              key={language.key}
              language={language.name}
              selectedLanguage={selectedLanguage}
              onClick={(language: string) => {
                setSelectedLanguage(language);
                disptchCTAClickObject(villageName, 'button', 'LanguageSelectModal', language, '');
                setActive();
              }}
            />
          ))}
        </Box>

        {/* <Box
          h="46px"
          w="120px"
          border="1px solid #455255"
          display="flex"
          alignItems="center"
          justifyContent="center"
          cursor="pointer"
          mt="10"
          mx="auto"
          _hover={{ color: 'white', bg: '#C29F6B', border: '1px solid #C29F6B' }}
          onClick={onLanguageSelect}
        >
          <Text fontWeight="400" fontSize={['12px', '12px', '12px', '14px', '14px']} fontFamily="JosefinSans">
            SELECT
          </Text>
        </Box> */}
      </Box>
    </>
  );
};

export default SelectLanguage;
